<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :label="attribute.mandatory ? ($attrs.label + ' *') : $attrs.label"
    :counter="attribute.maxLength"
    :rules="rules"
  ></v-text-field>
</template>

<script>
export default {
  name: 'ShortTextAttribute',
  props: {
    attribute: {
      type: Object,
      required: true
    }
  },
  computed: {
    rules () {
      const list = []
      if (this.attribute.mandatory) {
        list.push((v) => !!v || `${this.$attrs.label} är obligatorisk`)
      }
      if (this.attribute.maxLength) {
        list.push((v) => (!v || v.length <= this.attribute.maxLength) || `Du kan ange max ${this.attribute.maxLength} tecken i detta fält`)
      }
      return list
    }
  }
}
</script>
